import React, { useState, useEffect } from 'react';
import { Button, Card, Spinner, Alert, Badge } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

import Constants from '../Constants';
import { useAuth } from '../AuthContext';
import '../App.css';

const load_templates = async (token, set_templates, set_loading, set_error) => {
	set_loading(true);
	set_error('');
	try {
		const headers = token ? { Authorization: 'Bearer ' + token } : {};
		const response = await axios.get(Constants.SERVER_URL + '/api/call/templates', { headers });
		set_templates(response.data.templates || []);
	} catch (error) {
		set_error('Failed to load agents.');
	} finally {
		set_loading(false);
	}
};

const render_loading = () => {
	return (
		<div className="agents-loading">
			<Spinner animation="border" />
		</div>
	);
};

const render_error = (error_message) => {
	return (
		<Alert variant="danger">{error_message}</Alert>
	);
};

const render_view_toggle = (view_mode, set_view_mode) => {
	return (
		<div className="agents-view-toggle">
			{/* <Button
				size="sm"
				variant={view_mode === 'cards' ? 'primary' : 'outline-secondary'}
				onClick={() => set_view_mode('cards')}>
				Cards
			</Button> */}
			{/* <Button
				size="sm"
				variant={view_mode === 'table' ? 'primary' : 'outline-secondary'}
				onClick={() => set_view_mode('table')}>
				Table
			</Button> */}
		</div>
	);
};

const render_agent_card = (template, navigate) => {
	return (
		<Card key={template.id} className="agent-card">
			<Card.Body>
				<Card.Title className="agent-card-title">{template.name}</Card.Title>
			</Card.Body>
			<Card.Footer className="agent-card-footer">
				<Button
					size="sm"
					variant="primary"
					onClick={() => navigate('/agents/' + template.id, { state: { template } })}>
					Edit
				</Button>
			</Card.Footer>
		</Card>
	);
};

const render_cards = (templates, navigate) => {
	if(templates.length === 0) {
		return (
			<p className="agents-empty">No agents found. Create one to get started.</p>
		);
	}
	return (
		<div className="agents-cards-grid">
			{templates.map(template => render_agent_card(template, navigate))}
		</div>
	);
};

const render_table = () => {
	return (
		<div className="agents-table-placeholder">
			<p className="text-muted">Table view - coming soon.</p>
		</div>
	);
};

const render_content = (templates, view_mode, navigate) => {
	if(view_mode === 'table') {
		return render_table();
	}
	return render_cards(templates, navigate);
};

function AgentsView() {
	const { token } = useAuth();
	const navigate = useNavigate();

	const [templates, set_templates] = useState([]);
	const [loading, set_loading] = useState(false);
	const [error, set_error] = useState('');
	const [view_mode, set_view_mode] = useState('cards');

	useEffect(() => {
		load_templates(token, set_templates, set_loading, set_error);
	}, [token]);

	return (
		<React.Fragment>
			<main className="agents-main">
				<div className="agents-header">
					<h2>Agents</h2>
					<div className="agents-header-actions">
						{render_view_toggle(view_mode, set_view_mode)}
						<Button
							variant="primary"
							className="ms-3"
							onClick={() => navigate('/agents/new')}>
							New Agent
						</Button>
					</div>
				</div>
				{loading && render_loading()}
				{error && render_error(error)}
				{!loading && !error && render_content(templates, view_mode, navigate)}
			</main>
		</React.Fragment>
	);
}

export default AgentsView;
